import React, { FC } from 'react'
import Switch, { SwitchProps } from '@mui/material/Switch'
import styles from './styles'

const CustomToggle: FC<SwitchProps> = props => <Switch sx={styles.ToggleRoot} {...props} />

export default CustomToggle
